export default __webpack_public_path__ + "i18n/translations/translation-tr.51334de3.json";